import { Box, styled } from '@mui/material';
import { IconButton } from '@sdb/planning-ui';

export const Container = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  borderRadius: theme.shape.borderRadius,
  overflow: 'hidden',
  boxShadow: theme.shadows[8]
}));

export const ContentContainer = styled(Box, {
  shouldForwardProp: (propName) => propName !== 'columnCount'
})<{ columnCount?: number }>(({ theme, columnCount = 1 }) => ({
  display: 'grid',
  gridTemplateColumns: `repeat(${columnCount}, 1fr)`,
  gap: '1px',
  padding: theme.spacing(4),
  backgroundColor: theme.palette.background.paper,
  justifyContent: 'space-between',
  '&:not(:last-child)': {
    paddingBottom: 0
  }
}));

export const Header = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '50px',
  boxSizing: 'border-box',
  backgroundColor: theme.palette.background.default,
  borderBottom: `1px solid ${theme.palette.divider}`
}));

export const Section = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: theme.spacing(4),
  '&:not(:last-of-type)': {
    borderRight: `1px solid ${theme.palette.divider}`
  },

  '&:first-of-type': {
    paddingRight: theme.spacing(4)
  },

  '&:last-of-type': {
    paddingLeft: theme.spacing(4)
  }
}));

export const ViewOptionsButton = styled(IconButton)(({ theme }) => ({
  width: '32px',
  height: '32px',
  padding: theme.spacing(4),
  backgroundColor: theme.palette.background.paper,
  border: `1px solid ${theme.vars.palette.primary.main}`,
  color: theme.vars.palette.primary.main,
  '&:hover': {
    backgroundColor: theme.palette.action.hover
  }
}));
